import TourGuide from './tourGuide'
export default TourGuide
